import { DataService } from "@/services/data";
import { PaginatedResponse } from "@/types/common";
import { FundingOrganismSessionType } from "@/types/content/registration/funding_organism_session";
import { ProductSessionSeatsType, ProductSessionType } from "@/types/content/product_session";
import { ProductThemeCatalogAvailabilityResponse } from "@/types/content/product_theme_availability";
import { handle_error, handle_success } from "@/utils/wretch";
import { RouteObject } from "react-router-dom";

const PicklistRoute: RouteObject = {
    path: "picklists",
    children: [
        {
            id: "product_themes_catalog_availability",
            path: "product_themes/catalog_availability",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                try {
                    return handle_success(
                        (await DataService.client
                            .url(`/content/product_themes/catalog_availability/?${url.searchParams.toString()}`)
                            .get()
                            .json()) as ProductThemeCatalogAvailabilityResponse
                    );
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            id: "catalogue_funding_organism_sessions",
            path: "funding_organism_sessions",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "20");
                try {
                    return handle_success(
                        (await DataService.client
                            .url(`/content/funding_organism_sessions/?${url.searchParams.toString()}`)
                            .get()
                            .json()) as PaginatedResponse<FundingOrganismSessionType>
                    );
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            id: "product_sessions",
            path: "product_sessions",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "5");
                console.log(url.searchParams.toString());
                try {
                    return handle_success(
                        (await DataService.client
                            .url(`/content/product_sessions/?${url.searchParams ? url.searchParams.toString() : ""}`)
                            .get()
                            .json()) as PaginatedResponse<ProductSessionType>
                    );
                } catch (error) {
                    return handle_error(error);
                }
            },
            children: [
                {
                    path: ":id/seats",
                    loader: async ({ params }) => {
                        const id = params.id;
                        try {
                            return handle_success((await DataService.client.url(`/content/product_sessions/${id}/seats`).get().json()) as ProductSessionSeatsType);
                        } catch (error) {
                            return handle_error(error);
                        }
                    }
                }
            ]
        }
    ]
};
export default PicklistRoute;
